import React from "react";
import {useState} from "react";
import { Form, Field } from "react-final-form";
import { Tooltip } from "reactstrap";

// Components
import CustomFieldComponent from "./CustomFieldForm";

import * as Utils from "../../../utils";
import * as Models from "../../../models";
import ModalAlert from "../../Common/ModalAlert";

interface CustomTicket {
  customOid: string,
  ticketId: number,
}

// Ticket custom fields
let ticketsLength: number[] = new Array();
export let customTickets: CustomTicket[] = new Array();

export function TicketsLengthArray(ticketCount: number) {
  ticketsLength = [];
  for (var i = 0; i < ticketCount; i++) {
    ticketsLength.push(i)
  }
  return ticketsLength;
}

export function CustomTicketsArray(oid: string, ticketId: number) {
  if (!customTickets.some(i => i.customOid === ticketId.toString() + ";" + oid && i.ticketId === ticketId)) {
    customTickets.push({
      customOid: ticketId.toString() + ";" + oid,
      ticketId: ticketId,
    })
  }
  return customTickets;
}

const PostTransactionModal: React.FC<any> = (props: any) => {
  const [validateForm, setValidateForm] = useState<boolean>(false);
  const [cancelBooking, setCancelBooking] = useState<boolean>(false);
  
  // Tooltips
  const [ticketTooltipOpen, setTicketTooltipOpen] = useState<boolean>(false);
  const ticketToggle = () => setTicketTooltipOpen(!ticketTooltipOpen);
  const [idTooltipOpen, setIdTooltipOpen] = useState<boolean>(false);
  const idToggle = () => setIdTooltipOpen(!idTooltipOpen);
  const [nameTooltipOpen, setNameTooltipOpen] = useState<boolean>(false);
  const nameToggle = () => setNameTooltipOpen(!nameTooltipOpen);
  const [emailTooltipOpen, setEmailTooltipOpen] = useState<boolean>(false);
  const emailToggle = () => setEmailTooltipOpen(!emailTooltipOpen);
  const [phoneTooltipOpen, setPhoneTooltipOpen] = useState<boolean>(false);
  const phoneToggle = () => setPhoneTooltipOpen(!phoneTooltipOpen);
 
  // Maximum amount of tickets for a transaction
  var maxTickets = 10;
  if (props.selectedSession) {
    maxTickets = props.selectedSession.maxTicketsPerTransaction;
    if (maxTickets > props.selectedSession.availableTicketCount)
      maxTickets = props.selectedSession.availableTicketCount;
  }

  // Dropdown options to choose amount of tickets
  const optionItems: JSX.Element[] = [];
  for (var i = 1; i <= maxTickets; i++) {
    optionItems.push(
      <option key={i} value={i}>
        {i}
      </option>
    );
  }

  return (
    <div>
        <Form
          onSubmit={(values) => {
            let transactionCustomFields: Models.CustomField[] = props.customFields.filter((f: any) => f.scope === Utils.transactionField).map((item: any, i: number) => {
              let currentValue:string = values["custom" + item.oid];
              return ({
                customField: item.oid,
                ticketId:  0,
                value: item.type === 2 && currentValue === undefined
                ? 0 
                : item.type === 2 && currentValue[0] === "checked"
                ? 1
                : item.type === 4
                ? new Date(currentValue).toJSON()
                : currentValue
              })
            })

            let ticketCustomFields: Models.CustomField[] = customTickets.map((item: any) => {
              let currentValue:string = values[item.customOid];
              return ({
                customField: item.customOid.split(";")[1],
                ticketId:  item.ticketId,
                value: item.type === 2 && currentValue === undefined
                ? 0 
                : item.type === 2 && currentValue[0] === "checked"
                ? 1
                : item.type === 4
                ? new Date(currentValue).toJSON()
                : currentValue
              })
            })

            let data : Models.Transaction = {
              discountOid: values.discountOid ? values.discountOid : null,
              id: values.id,
              name: values.name,
              email: values.email,
              phone: values.phone,
              ticketCount: values.ticketCount ? Number(values.ticketCount) : 0,
              customFields: transactionCustomFields.concat(ticketCustomFields),
            };
            props.postTransaction(data, props.selectedSession.oid);
          }}
          render={({
            handleSubmit,
            form,
            submitting,
            valid,
            values,
          }) => (
            <form onSubmit={handleSubmit} className="needs-validation">
              <div className="modal-header">
                <h5 className="modal-title" id="reservaModalLabel">
                  Nova reserva
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    form.reset();
                    setCancelBooking(true);
                    props.setModal(false);
                    props.setModalAlert((alert: Models.Alert) => alert = {
                      text: "",
                      color: "",
                      visible: false,
                    });
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              
              <div className="modal-body">
                {props.selectedSession && props.selectedSession.activityName !== "" && !props.selectedSession.label && (<h6 className="blue2 mb-2">{props.selectedSession.activityName}</h6>)}
                {props.selectedSession && props.selectedSession.label && props.selectedSession.activityName === "" && (<h6 className="blue2 mb-2">{props.selectedSession.label}</h6>)}
                {props.selectedSession && props.selectedSession.label && props.selectedSession.activityName !== "" && (<h6 className="blue2 mb-2">{props.selectedSession.activityName} - {props.selectedSession.label}</h6>)}
                
                <ModalAlert {...props} />
                <p>
                  Dia i hora: {props.selectedSession?.startOnDate}{" "}
                  {props.selectedSession?.endOnTime ? " de " : " a les "}
                  {props.selectedSession?.startOnTime}
                  {props.selectedSession?.endOnTime
                    ? " a " + props.selectedSession?.endOnTime
                    : null}
                </p>
                
                {props.selectedSession?.canBuyTicketsWithoutDiscount && (
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <label
                        className="input-group-text"
                        htmlFor="inputGroupSelect01"
                        id="ticketTooltip"
                      >
                        Quantitat
                      </label>
                      <Tooltip
                        placement="top"
                        isOpen={ticketTooltipOpen}
                        target="ticketTooltip"
                        toggle={ticketToggle}
                        hideArrow={true}
                        style={{ backgroundColor: "#7c7c7c" }}
                      >
                        Número de tiquets que es volen reservar.
                      </Tooltip>
                    </div>
                    <Field
                      data-testid='ticketCountField'
                      name="ticketCount"
                      id="ticketTooltip"
                      component="select"
                      className={
                        validateForm && !values.ticketCount && !cancelBooking
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      validate={Utils.required}
                      onChange={(e: any) => {
                        form.change("ticketCount", e.target.value);
                        customTickets = [];
                      }}
                      defaultValue={optionItems.length === 1 ? optionItems[0].key : null}
                    >
                      <option>Seleccioneu una quantitat</option>
                      {optionItems}
                    </Field>
                    <div className="invalid-feedback">
                      {form.getFieldState("ticketCount") &&
                        form.getFieldState("ticketCount")?.error}
                    </div>
                  </div>
                )}

                {!props.selectedSession?.canBuyTicketsWithoutDiscount &&
                  props.discounts &&
                  props.discounts.length > 0 && (
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <label
                          className="input-group-text"
                          htmlFor="inputGroupSelect01"
                          id="ticketTooltip"
                        >
                          Quantitat
                        </label>
                        <Tooltip
                          placement="top"
                          isOpen={ticketTooltipOpen}
                          target="ticketTooltip"
                          toggle={ticketToggle}
                          hideArrow={true}
                          style={{ backgroundColor: "#7c7c7c" }}
                        >
                          Número de tiquets que es volen reservar.
                        </Tooltip>
                      </div>
                      <Field
                        data-testid='discountOidField'
                        id="ticketTooltip"
                        name="discountOid"
                        component="select"
                        className={
                          validateForm && !values.discountOid && !cancelBooking
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        validate={Utils.required}
                        onChange={(e: any) => {
                          form.change("discountOid", e.target.value);
                          customTickets = [];
                        }}
                        defaultValue={props.discounts.length === 1 ? props.discounts[0].oid : null}
                      >
                        {props.discounts.length > 1 && <option>Seleccioneu una quantitat</option>}
                        {props.discounts.map((discount: any, i: any) => (
                          <option key={i} value={discount.oid}>
                            {discount.name +
                              " " +
                              discount.requiredTicketsNumber}
                          </option>
                        ))}
                      </Field>
                      <div className="invalid-feedback">
                        {form.getFieldState("discountOid") &&
                          form.getFieldState("discountOid")?.error}
                      </div>
                    </div>
                  )}

                <div className="form-group">
                  <label
                    htmlFor="recipient-name"
                    className="col-form-label"
                    id="nameTooltip"
                  >
                    Nom i cognoms <strong>*</strong>
                  </label>
                  <Field
                    data-testid='nameField'
                    id="nameTooltip"
                    name="name"
                    component="input"
                    type="text"
                    className={
                      validateForm && !values.name && !cancelBooking
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    validate={Utils.required}
                  />
                  <Tooltip
                    placement="top"
                    isOpen={nameTooltipOpen}
                    target="nameTooltip"
                    toggle={nameToggle}
                    hideArrow={true}
                    style={{ backgroundColor: "#7c7c7c" }}
                  >
                    Nom i cognoms del responsable de la reserva.
                  </Tooltip>
                  <div className="invalid-feedback">
                    {form.getFieldState("name") &&
                      form.getFieldState("name")?.error}
                  </div>
                </div>

                <div className="form-group">
                  <label
                    htmlFor="message-text"
                    className="col-form-label"
                    id="idTooltip"
                  >
                    DNI <strong>*</strong>
                  </label>
                  <Field
                    data-testid='idField'
                    id="idTooltip"
                    name="id"
                    component="input"
                    type="text"
                    className={
                      validateForm && !values.id && !cancelBooking
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    validate={Utils.required}
                  />
                  <Tooltip
                    placement="top"
                    isOpen={idTooltipOpen}
                    target="idTooltip"
                    toggle={idToggle}
                    hideArrow={true}
                    style={{ backgroundColor: "#7c7c7c" }}
                  >
                    DNI del responsable de la reserva.
                  </Tooltip>
                  <div className="invalid-feedback">
                    {form.getFieldState("id") &&
                      form.getFieldState("id")?.error}
                  </div>
                </div>
                
                <div className="form-group">
                  <label
                    htmlFor="email-text"
                    className="col-form-label"
                    id="emailTooltip"
                  >
                    Correu electrònic <strong>*</strong>
                  </label>
                  <Field
                    data-testid='emailField'
                    id="emailTooltip"
                    name="email"
                    component="input"
                    type="text"
                    className={
                      validateForm &&
                      !cancelBooking &&
                      Utils.validateEmail(values.email) !== undefined
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    validate={Utils.validateEmail}
                  />
                  <Tooltip
                    placement="top"
                    isOpen={emailTooltipOpen}
                    target="emailTooltip"
                    toggle={emailToggle}
                    hideArrow={true}
                    style={{ backgroundColor: "#7c7c7c" }}
                  >
                    Adreça electrònica del responsable de la reserva. Un cop
                    formalitzada la reserva, rebreu un correu amb les dades de
                    la mateixa.
                  </Tooltip>
                  <div className="invalid-feedback">
                    {form.getFieldState("email") &&
                      form.getFieldState("email")?.error}
                  </div>
                </div>

                <div className="form-group">
                  <label
                    htmlFor="phone-text"
                    className="col-form-label"
                    id="phoneTooltip"
                  >
                    Telèfon <strong>*</strong>
                  </label>
                  <Field
                    data-testid='phoneField'
                    id="phoneTooltip"
                    name="phone"
                    component="input"
                    type="text"
                    className={
                      validateForm && !values.phone && !cancelBooking
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    validate={Utils.required}
                  />
                  <Tooltip
                    placement="top"
                    isOpen={phoneTooltipOpen}
                    target="phoneTooltip"
                    toggle={phoneToggle}
                    hideArrow={true}
                    style={{ backgroundColor: "#7c7c7c" }}
                  >
                    Telèfon del responsable de la reserva, a efectes de poder
                    posar-nos en contacte amb vosaltres en cas que hi hagués
                    alguna incidència.
                  </Tooltip>
                  <div className="invalid-feedback">
                    {form.getFieldState("phone") &&
                      form.getFieldState("phone")?.error}
                  </div>
                </div>

                {props.customFields.length > 0 && props.customFields.filter((i: any) => i.scope === Utils.transactionField).map((item: any) => {
                  return (
                      <CustomFieldComponent
                        key={item.oid}
                        item={item}
                        validateForm={validateForm}
                        form={form}
                        values={values}
                      />
                    )
                  })}
                  
                  {values.ticketCount && props.customFields.length > 0 && TicketsLengthArray(values.ticketCount).map(i => {
                    return (
                      <div key={i}>
                        <strong>Tiquet {++i}</strong>
                        {
                            props.customFields.filter((cf: any) => cf.scope === Utils.ticketField).map((item: any) => {
                              CustomTicketsArray(item.oid, i);
                              return (
                                <CustomFieldComponent
                                  key={item.oid}
                                  item={item}
                                  validateForm={validateForm}
                                  form={form}
                                  values={values}
                                  customOid={i.toString() + ";" + item.oid}
                                />
                              )
                            }
                          )
                        }
                      </div>
                    )
                  })}

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                    onClick={() => {
                      form.reset();
                      setCancelBooking(true);
                      props.setModal(false);
                      props.setModalAlert((alert: Models.Alert) => alert = {
                        text: "",
                        color: "",
                        visible: false,
                      });
                    }}
                  >
                    Cancel·lar
                  </button>
                  <button
                    data-testid='form'
                    type="submit"
                    className="btn btn-primary"
                    disabled={submitting || props.submittingForm}
                    onClick={(e: any) => {
                      setValidateForm(true);
                      setCancelBooking(false);
                      e.preventDefault();
                      if (valid) {
                        props.setSubmittingForm(true);
                        form.submit();
                      }
                    }}
                  >
                    Reservar
                  </button>
                </div>
              </div>
            </form>
          )}
        />
    </div>
  );
};

export default PostTransactionModal;
